const { defineTheme, value } = require('@dbk/com.db.dbk.theme-utils');

module.exports = defineTheme('donut-chart', {
  /**
   * @label Trianlge colour
   * @editor color
   */
  triangleColor: value('color', '#232323'),

  /**
   * @label DonutChart border colour
   * @editor color
   */
  borderColor: value('color', 'transparent'),

  /**
   * @label DonutChart inactive colour
   * @editor color
   */
  inactiveColor: value('color', '#8996a0'),
});
